import { ProjectQuestionInsightsProps } from '@/types';
import AnalysisSection from '@/components/analysis/AnalysisSection';
import InsightCardList from '@/components/analysis/InsightCardList';
import { formatSectionsForClipboard } from '@/utils/formatForClipboard';

function ProjectQuestionInsights({
  data,
  isLoading,
  title,
  noDataText,
  icon,
  voiceQuotes,
}: ProjectQuestionInsightsProps) {
  const hasData = !!data && data.length > 0;

  return (
    <AnalysisSection
      title={title}
      icon={icon}
      copyText={hasData ? formatSectionsForClipboard(data) : undefined}
      hasData={hasData}
      noDataText={noDataText}
      isLoading={isLoading}
    >
      <InsightCardList data={data} isLoading={isLoading} voiceQuotes={voiceQuotes} />
    </AnalysisSection>
  );
}

export default ProjectQuestionInsights;
